import axios from 'axios';

const api = axios.create({
    baseURL: '/api/v1',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status  = error.response?.status;
        const message = error.response?.data?.message;
        const url     = error.config?.url ?? '';

        // Trasy publicznego udostępniania obsługuje anonimowy odbiorca — 401
        // znaczy tam „złe hasło do linku", a nie „wygasła sesja". Bez tego
        // wyjątku wpisanie błędnego hasła wyrzucało gościa na ekran logowania
        // (znalezione przy naprawie komunikatów 2026-07-31).
        const publiczna = url.startsWith('/s/') || url.includes('/api/v1/s/');

        // Samo logowanie tak samo: 401 znaczy tam „złe hasło", nie „wygasła
        // sesja". Przeładowanie strony gasiło komunikat, zanim ktokolwiek go
        // zobaczył — błędne hasło wyglądało jak nic (2026-08-12, przy
        // przywracaniu logowania hasłem).
        const logowanie = url === '/login' || url.endsWith('/api/v1/login');

        if (status === 401 && !url.includes('/me') && !publiczna && !logowanie) {
            localStorage.removeItem('auth_token');
            window.location.href = '/login';
            return Promise.reject(error);
        }

        // Widok obsługuje błąd sam i pokazuje własny komunikat — globalny toast
        // byłby drugą, mniej precyzyjną wiadomością o tym samym
        if (error.config?.skipErrorToast) {
            return Promise.reject(error);
        }

        if (status && status !== 422) {
            import('@/stores/toast').then(({ useToastStore }) => {
                const msg = message
                    ?? (status === 403 ? 'Brak uprawnień do tej operacji.'
                    :  status === 404 ? 'Nie znaleziono zasobu.'
                    :  status >= 500  ? 'Błąd serwera. Spróbuj ponownie.'
                    :  'Coś poszło nie tak.');
                useToastStore().error(msg);
            });
        }

        return Promise.reject(error);
    },
);

export default api;
